/* eslint-disable jira/filename-case */
export const STAR = 'star';
export const UNSTAR = 'unstar';

export type StarType = typeof STAR | typeof UNSTAR;
